<template>
	<div v-if="goodsObj.image == undefined"></div>
	<div class="undeteDteil" v-else>
		<div class="nav">
			<van-icon name="arrow-left" color="#fff" size="1.1rem" @click="back" />
			<span>商品详情</span>
			<span></span>
		</div>
		<!-- 顶部轮播图 -->
		<div class="swiper">
			<van-swipe :autoplay="2000">
				<van-swipe-item v-for="item in goodsObj.image">
					<img :src="item | handleUrl" alt="">
				</van-swipe-item>
				<div class="custom-indicator" slot="indicator">
					{{ current + 1 }}/{{goodsObj.image.length}}
				</div>
			</van-swipe>
		</div>
		<!-- 商品介绍 -->
		<div class="column">
			<div class="title">
				{{goodsObj.title}}
			</div>
			<div class="main">
				<div>{{goodsObj.price | formarter}}</div>
				<div>
					<div>{{goodsObj.create_time}}</div>
					<div class="center">
						<span>发布于</span>
						<span style="color:#F1452F">{{goodsObj.city}}</span>
					</div>
					<div>{{goodsObj.browse}}人浏览</div>
				</div>
			</div>
			<div class="foot">
				<div>
					<van-icon class="location_o" name="location-o" color="#F1452F" size="1rem" />
					<div style="font-size: 12px; color: #2f2f2f;">{{goodsObj.province}}{{goodsObj.city}}{{goodsObj.area}}{{goodsObj.address}}</div>
				</div>
			</div>
			<div class="foots">
				<div style="color: #b1b1b1; font-size: 12px;">据您当前位置{{goodsObj.km}}km</div>
			</div>
		</div>
		<!-- 商品详情 -->
		<div class="msg">
			<div>商品详情</div>
			<div>{{goodsObj.content}}</div>
		</div>
		<!-- 参数规格 -->
		<div class="norms">
			<van-cell>
				<div slot="default" class="norms-value">
					<span>新旧</span>
					<span>{{goodsObj.new_old}}</span>
				</div>
			</van-cell>
			<van-cell>
				<div slot="default" class="norms-value">
					<span>类别</span>
					<span>{{goodsObj.category_name}}</span>
				</div>
			</van-cell>
			<van-cell>
				<div slot="default" class="norms-value">
					<span>规格</span>
					<span>{{goodsObj.specifications}}</span>
				</div>
			</van-cell>
			<van-cell>
				<div slot="default" class="norms-value">
					<span>数量</span>
					<span>{{goodsObj.num}}</span>
				</div>
			</van-cell>
			<van-cell @click="callPhone(goodsObj.tel)">
				<div slot="default" class="norms-value">
					<span>联系人</span>
					<span>{{goodsObj.tel | phoneNumFilter}}</span>
				</div>
				<div slot="right-icon" class="consult">
					<van-icon name="phone-o" color="#F1452F" size="1rem" />
					<div>咨询</div>
				</div>
			</van-cell>
		</div>
		<!-- 商品详情 -->
		<!-- <van-divider :style="{ color: '#000', borderColor: '#e0e0e0', padding: '0 16px' }">商品图片</van-divider>
		<div class="hengfu">
			<img v-for="item in goodsObj.image" :src="item | handleUrl" alt="">
		</div> -->
		<!-- 关于卖家 -->
		<div class="user-msg" @click="toPos()">
			<!-- <div>关于卖家</div> -->
			<div class="contain">
				<div class="contain-left">
					<img src="../../assets/user.png" alt="" v-if="goodsObj.user.image == null">
					<img :src="goodsObj.user.image | handleUrl" alt="" v-else>
					<div>
						<div>{{goodsObj.user.username}}</div>
						<div>
							<!-- <van-button color="#f1452f" plain round size="mini" style="padding:0 0.7rem;"></van-button> -->
							<van-button color="#f1452f" round size="mini" style="padding:0 0.7rem; width: 10rem;">全部宝贝</van-button>
							<!-- <span>发布于</span> -->
							<!-- <span class="f1452f">{{goodsObj.province}}{{goodsObj.city}}{{goodsObj.area}}</span> -->
						</div>
					</div>
				</div>
				<div class="contain-right">
					<div>在售宝贝</div>
					<div>{{goodsObj.count}}</div>
				</div>
			</div>
		</div>
		<van-divider :style="{ color: '#F1452F', borderColor: '#F1452F', padding: '0 5rem' }">
			猜您喜欢
		</van-divider>
		<Like :id="id"></Like>
		<van-goods-action>
			<van-goods-action-icon icon="wap-home-o" text="首页" to="/Home" />
			<van-goods-action-icon icon="like-o" text="收藏" @click='onClickIcon' />
			<van-goods-action-button type="danger" text="拨打电话" @click="callPhone(goodsObj.tel)" />
		</van-goods-action>
	</div>
</template>

<script>
	import Like from '@/components/like/prefer'
	import Customerservice from '@/components/customerservice'

	export default {
		data() {
			return {
				current: 0, //角标
				goodsObj: {},
				id: this.$route.query.id
			}
		},
		created() {
			this.$axios.post(baseUrl + '/mobile/Fta/ftaInfo', {
				id: this.$route.query.id,
				lng: this.$store.state.location[0],
				lat: this.$store.state.location[1]
			}).then((res) => {
				if (res.data.code == 2) {
					this.goodsObj = res.data.data;
				}
			}).catch((err) => {
				console.log(err);
			});
		},
		methods: {
			toPos() {
				this.$router.push({
					path: '/Pos',
					query: {
						id: this.goodsObj.user.id
					}
				})
			},
			// 调用拨号功能
			callPhone(phoneNumber) {
				window.location.href = 'tel://' + phoneNumber
			},
			//收藏信息
			onClickIcon() {
				// this.whatLogin((bool) => {
				// 	if (bool) {
				// 		this.$axios.post(baseUrl + '/mobile/Base/goodsCollection', {
				// 			id: this.$route.query.id,
				// 			token: localStorage.getItem('Authorization')
				// 		}).then((res) => {
				// 			if (res.data.code == 15) {
				// 				this.$toast(res.data.msg);
				// 				this.collection = !this.collection;

				// 			} else if (res.data.code == 17) {
				// 				this.$toast(res.data.msg);
				// 				this.collection = !this.collection;
				// 			}
				// 			this.shokaiww = false
				// 		}).catch((err) => {
				// 			console.log(err);
				// 		})
				// 	} else {
				// 		this.$router.push({
				// 			path: 'login',
				// 			// query: {
				// 			// 	id: this.$route.query.id
				// 			// }
				// 		});
				// 	}
				// })
				
			},
		},
		components: {
			Like,
			Customerservice,
		}
	}
</script>

<style scoped>
	.undeteDteil {
		padding: 2rem 0 3rem 0;
	}

	.undeteDteil .swiper {
		position: relative;
		margin: 1px 0;
		background: #fff;
	}

	.undeteDteil .swiper .header {
		width: 100%;
		padding: 1.5rem 0.5rem 0 0.5rem;
		box-sizing: border-box;
		position: absolute;
		top: 0;
		z-index: 999;
		display: flex;
		justify-content: space-between;
	}

	.undeteDteil .van-swipe-item img {
		width: 100%;
		object-fit: contain;
		max-height: 25rem;
		display: block;
	}

	.undeteDteil .column {
		padding-top: 0.5rem;
		color: #262626;
		text-align: left;
		border-radius: 0 0 0.5rem 0.5rem;
		background: #fff;
	}

	.undeteDteil .column .title {
		font-size: 0.85rem;
		color: #000;
		font-weight: bold;
	}

	.undeteDteil .column .title,
	.undeteDteil .column .main {
		padding: 0 0.7rem;
	}

	.undeteDteil .column .main {
		display: flex;
		justify-content: space-between;
		color: #c1c1c1;
		margin: 0.5rem 0;
	}

	.undeteDteil .column .main a {
		color: #F1452F;
		margin: 0;
	}

	.undeteDteil .column .main .center {
		margin: 0 0.5rem;
	}

	.undeteDteil .column .main>div:nth-child(1) {
		color: #F1452F;
	}

	.undeteDteil .column .main>div:nth-child(2) {
		display: flex;
		font-size: 0.75rem;
		align-items: center;
	}

	.undeteDteil .column .foot {
		width: 100%;
		border-top: 1px solid #f0eff5;
		display: flex;
		justify-content: space-between;
		font-size: 0.8rem;
		padding: 0.7rem 0.7rem 0.3rem 0.7rem;
		box-sizing: border-box;
		color: #494949;
	}

	.undeteDteil .column .foots {
		width: 100%;
		padding: 0 0 0.7rem 1.7rem;
	}

	.undeteDteil .column .foot>div:nth-child(1) {
		width: 90%;
		color: #979797;
		display: flex;
		line-height: 1.5rem;
	}

	.undeteDteil .column .foot>div:nth-child(2) {
		color: #F1452F;
		display: flex;
		align-items: center;
	}

	.undeteDteil .column .foot .location_o {
		display: flex;
		align-items: center;
		height: 1rem;
		margin-top: 4px;
	}

	.undeteDteil .norms .consult {
		display: flex;
		align-items: center;
		color: #F1452F;
	}

	.undeteDteil .norms .van-cell {
		font-size: 0.8rem;
	}

	.undeteDteil .norms .norms-value {
		text-align: left;
	}

	.undeteDteil .norms .norms-value span:nth-child(1) {
		display: inline-block;
		width: 4rem;
		color: #999999;
		margin-right: 1rem;
	}

	.undeteDteil .hengfu {
		margin: 1rem 0;
	}

	.undeteDteil .hengfu img {
		width: 100%;
		height: 100%;
		object-fit: contain;
	}

	.undeteDteil .msg,
	.undeteDteil .user-msg {
		background: #fff;
		border-radius: 0.5rem;
		padding: 0.5rem 1rem;
		box-sizing: border-box;
		text-align: left;
		margin: 0.8rem 0;
	}

	.undeteDteil .msg div:nth-child(1) {
		padding-bottom: 0.5rem;
		border-bottom: 1px dashed #ebedf0;
	}

	.undeteDteil .msg div:nth-child(1),
	.undeteDteil .user-msg>div:nth-child(1) {
		font-size: 0.8rem;
		color: #333333;
		margin-bottom: 0.5rem;
	}

	.undeteDteil .msg div:nth-child(2) {
		color: #979797;
		font-size: 0.8rem;
		line-height: 1.5rem;
	}

	.undeteDteil .user-msg .contain {
		display: flex;
		font-size: 0.75rem;
		margin-top: 0.5rem;
	}

	.undeteDteil .user-msg .contain-left {
		display: flex;
		width: 80%;
		border-right: 1px solid #f0eff5;
	}

	.undeteDteil .user-msg .contain-left a {
		color: #F1452F;
	}

	.undeteDteil .user-msg .contain-left>div {
		display: flex;
		padding-right: 0.5rem;
		flex-direction: column;
		justify-content: space-around;
	}

	.undeteDteil .user-msg .contain-left img {
		width: 4rem;
		height: 4rem;
		border-radius: 0.4rem;
		margin-right: 1rem;
	}

	.undeteDteil .user-msg .contain-right {
		padding-left: 0.5rem;
		display: flex;
		flex-direction: column;
		justify-content: space-around;
		align-items: center;
		width: 20%;
		color: #9d9d9d;
	}

	.undeteDteil .user-msg .f1452f {
		color: #F1452F;
	}
</style>



// WEBPACK FOOTER //
// src/components/home/undeteDteil.vue